<template>
  <div class="concern-problem">
    <div class="content-center">
      <div class="module-header">
        <div class="module-title">老板最关心的4个问题</div>
      </div>
      <div class="module-body">
        <div class="dialogue-item user">
          <div class="dialogue-text">成为云企业后，原企业的独立性是否影响？</div>
        </div>
        <div class="dialogue-item ylc">
          <div class="dialogue-text">不受影响。云企业是为原企业提供的资源支撑工具，企业原有经营模式、决策权及财务独立性均保持不变。</div>
        </div>
        <div class="dialogue-item user">
          <div class="dialogue-text">使用平台资质及资源的费用如何计算？</div>
        </div>
        <div class="dialogue-item ylc">
          <div class="dialogue-text">注册及资质使用免费，仅在项目落地后按比例收取服务费，远低于自建资质及团队的成本。</div>
        </div>
        <div class="dialogue-item user">
          <div class="dialogue-text">项目资金是否需经过平台，安全性如何？</div>
        </div>
        <div class="dialogue-item ylc">
          <div class="dialogue-text">平台提供云企业虚拟账户，项目资金直接由甲方支付至云企业自身账户；账户资金看板实时更新，全流程受国家信息安全认证保护，资金流向可追溯。</div>
        </div>
        <div class="dialogue-item user">
          <div class="dialogue-text">缺乏大型项目经验，承接后能否顺利完成？</div>
        </div>
        <div class="dialogue-item ylc">
          <div class="dialogue-text">平台提供全流程支持：从方案设计到施工监理，配备专业人员协助实施，确保项目从 “能接” 到 “能做好”。</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
};
</script>

<style lang="less" scoped>
.concern-problem {
  padding: 64px 0;
  background-color: #fff;

  .content-center {
    .module-body {
      padding: 24px 0;
      .dialogue-item {
        display: flex;
        position: relative;
        & + .dialogue-item {
          margin-top: 24px;
        }
        &::before {
          content: '';
          width: 48px;
          height: 48px;
          background-size: 48px 48px;
          position: absolute;
          top: 0;
        }
        &::after {
          font-size: 14px;
          color: #666;
          position: absolute;
          top: 0;
        }
        .dialogue-text {
          max-width: 1024px;
          padding: 12px 24px;
        }
        &.user {
          padding: 28px 0 0 62px;
          justify-content: flex-start;
          &::before {
            background-image: url('@/assets/img/cooperation/ConcernProblem/avatar_user.png');
            left: 0;
          }
          &::after {
            content: '用户';
            left: 62px;
          }
          .dialogue-text {
            background: linear-gradient(180deg, #FFF4E7 0%, #FFF1E6 100%);
            box-shadow: 0px 3px 0px 0px #FAD39D;
            border-radius: 0 10px 10px 10px;
          }
        }
        &.ylc {
          padding: 28px 62px 0 0;
          justify-content: flex-end;
          &::before {
            background-image: url('@/assets/img/cooperation/ConcernProblem/avatar_ylc.png');
            right: 0;
          }
          &::after {
            content: '易隆创';
            right: 62px;
          }
          .dialogue-text {
            background: linear-gradient(180deg, #FF8100 0%, #FF9B02 100%);
            box-shadow: 0px 3px 0px 0px #FF4D00;
            border-radius: 10px 0px 10px 10px;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
